var _rect, _rect2, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9388 9.9932C16.9388 12.0406 16.1114 13.8905 15.0833 15.3954C14.0566 16.8984 12.8558 18.0185 12.1752 18.5932C12.0694 18.6826 11.931 18.6826 11.8251 18.5932C11.1446 18.0185 9.94391 16.8984 8.91724 15.3954C7.88926 13.8905 7.06191 12.0406 7.06191 9.9932C7.06191 7.44983 9.27978 5.1 12.0001 5.1C14.7206 5.1 16.9388 7.4499 16.9388 9.9932Z",
    stroke: "#444444",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0006,
    cy: 9.96598,
    r: 1.37369,
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0aa25039cea4f2f604c5ad8626dac786.svg";
export { ForwardRef as ReactComponent };